import { render } from "./ShowAttributeMaster.vue?vue&type=template&id=3a4205fe"
import script from "./ShowAttributeMaster.vue?vue&type=script&lang=js"
export * from "./ShowAttributeMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__